const pricingPlans = [
  {
    title: 'Personal',
    tier: 1,
    monthlyPrice: '$29',
    annualPrice: '$24',
    description: 'For investors needing to centralize and visualize their widespread portfolio.',
    features: [
      { title: 'Accounts', quantity: 10, enabled: true },
      { title: 'Integrations', quantity: 5, enabled: true },
      { title: 'Assessments', quantity: 15, enabled: true },
      { title: 'Collaborators', quantity: null, enabled: false },
      { title: 'Multiple Portfolios', quantity: null, enabled: false },
    ],
  },
  {
    title: 'Professional',
    tier: 2,
    monthlyPrice: '$89',
    annualPrice: '$79',
    description: 'For sophisticated investors needing mission critical insights on their data to make informed investment decisions.',
    features: [
      { title: 'Accounts', quantity: 30, enabled: true },
      { title: 'Integrations', quantity: 15, enabled: true },
      { title: 'Assessments', quantity: 40, enabled: true },
      { title: 'Collaborators', quantity: null, enabled: false },
      { title: 'Multiple Portfolios', quantity: null, enabled: false },
    ],
  },
  {
    title: 'Advanced',
    tier: 3,
    monthlyPrice: '$599',
    annualPrice: '$499',
    description: 'For high net worth individuals needing an all-in-one portfolio management suite for custom reporting across all asset classes and entities.',
    features: [
      { title: 'Accounts', quantity: 200, enabled: true },
      { title: 'Integrations', quantity: 25, enabled: true },
      { title: 'Assessments', quantity: 300, enabled: true },
      { title: 'Collaborators', quantity: null, enabled: true },
      { title: 'Multiple Portfolios', quantity: null, enabled: true },
    ],
  },
];

export default pricingPlans;




// WEBPACK FOOTER //
// ./src/services/pricingPlans.js